import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
 title: '',
 navigateBackTo: '',
 loading: false,
};

const appbarSlice = createSlice({
    name: 'appbar',
    initialState,
    reducers: {
        setAppbar: (state, action) => {
            // state = {...action.payload};
            return {...action.payload};
        },
        resetAppbar: state => {
            return {
                ...initialState
            };
        },
        setAppbarLoading: (state, action) => {
            state.loading = action.payload;
        }
    },
});


export const { setAppbar, resetAppbar, setAppbarLoading } = appbarSlice.actions;
export default appbarSlice.reducer;
